<template lang="pug">
el-button(type="primary", @click="update($event)") Salvar &nbsp
    .fa.fa-save
</template>

<script>
export default {
  name: 'SalvarModelo',
  props: ['modelValue'],
  methods: {
    update ($event) {
      this.$emit('update:modelValue', $event.returnValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/analise/components/SalvarModelo.vue